export default __webpack_public_path__ + "28398c83e8184cb6cbf10418b2f130c9.png";